/*=========================================================================================
  File Name: modulePermissionsState.js
  Description: Permissions Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	permissions: [],
	roles: [],
	role_permissions: [],
};
